<template>
    <div v-if="normalizedContent">
        <!-- Legal agreement HTML sanitized with DOMPurify. -->
        <!-- eslint-disable vue/no-v-html -->
        <div class="legal-agreement-pdf-content" v-html="normalizedContent" />
        <!-- eslint-enable vue/no-v-html -->
    </div>
    <div v-else>An error occurred while generating document. Please contact support.</div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useSanitizeHtml} from '@malt/utils';

    interface Props {
        content: string;
    }

    const {content} = defineProps<Props>();
    const {sanitizeHtml} = useSanitizeHtml();

    const normalizedContent = computed<string>(() =>
        sanitizeHtml(
            content
                .replace(/&nbsp;/gi, ' ')
                .replace(/&#160;/g, ' ')
                .replace(/\u00A0/g, ' '),
        ),
    );
</script>

<style lang="scss" scoped>
    @page {
        margin: var(--joy-core-spacing-12);
    }

    .legal-agreement-pdf-content {
        span {
            overflow-wrap: normal;
            word-break: normal;
        }
    }
</style>
